import { DataHandlerSnapshot, Snapshot } from "luxedo-data"
import { SnapshotAPI } from "../../modules/SnapshotAPI"

type SnapshotModifierView = "select" | "mask"
export type SnapshotModifyCallback = (snap: Snapshot) => void

export class SnapshotModifierController {
	view: SnapshotModifierView = $state("select")

	groupId: number
	selectedSnapshot: Snapshot = $state()
	availableSnapshots: Array<Snapshot> = $state([])

	onComplete: SnapshotModifyCallback
	cancel: () => void

	constructor(snapshots: Array<Snapshot>, onComplete: SnapshotModifyCallback, cancel: () => void) {
		this.availableSnapshots = snapshots
		this.onComplete = onComplete
		this.cancel = cancel

		if (snapshots.length === 1) {
			this.selectSnapshot(snapshots[0])
			this.view = "mask"
		}
	}

	/**
	 * Sets the specified snapshot as the selected snapshot, refreshes the available masks.
	 */
	selectSnapshot = (snapshot: Snapshot) => {
		this.selectedSnapshot = snapshot
	}

	/**
	 * Save image as a new snapshot
	 */
	saveSnapshot = async (imgBlob: Blob) => {
		const newSnapId = await SnapshotAPI.saveEditedSnapshot(imgBlob, this.selectedSnapshot.cal_id)
		await DataHandlerSnapshot.pull([newSnapId])
		const snapshot = DataHandlerSnapshot.get(newSnapId)
		this.onComplete(snapshot)
	}

	/**
	 * Sets the current "view" (used in the component to determine what to render)
	 */
	setView = (view: SnapshotModifierView) => {
		this.view = view
	}
}
